import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export const StyledFlexParent = styled(Flexer.Parent)`
  width: 100%;
  margin: -0.8rem -0.8rem;
`;

export const StyledFlexChild = styled(Flexer.Child)`
  width: calc(33% - 1.6rem);
  margin: 0.8rem;
  max-width: 27rem;
`;
